// PaymentSuccess.jsx
import { useEffect, useState } from "react";
import { useLocation } from "wouter";
import axiosClient from "@/lib/axiosClient";
import { Loader } from "@/components/ui/loader";

export function PaymentSuccess() {
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Extract customPaymentId and gameId from URL query params
  const params = new URLSearchParams(window.location.search);
  const customPaymentId = params.get("customPaymentId");
  const gameId = params.get("gameId");

  useEffect(() => {
    if (!customPaymentId) {
      setError("Отсутствует идентификатор платежа в URL.");
      setLoading(false);
      return;
    }

    // Function to poll the payment status
    const pollPaymentStatus = async () => {
      try {
        const response = await axiosClient.get(
          `/api/payment-status?customPaymentId=${customPaymentId}`
        );
        const status = response.data.status;
        setPaymentStatus(status);

        // If payment is successful or waiting for capture, update status on server
        if (status === "succeeded" || status === "waiting_for_capture") {
          await axiosClient.post("/api/purchases/update-status", {
            customPaymentId,
            status: "completed",
          });
        }
        setLoading(false);

        // If payment is canceled, we consider it "done loading"
        // else if (status === "canceled") {
        //   await axiosClient.post("/api/purchases/update-status", {
        //     customPaymentId,
        //     status: status,
        //   });
        //   setLoading(false);
        // }
      } catch (err) {
        console.error("Ошибка получения статуса платежа:", err);
        setError("Не удалось получить статус платежа.");
        setLoading(false);
      }
    };

    // Poll immediately, then every 5 seconds
    pollPaymentStatus();
    const interval = setInterval(pollPaymentStatus, 5000);

    return () => clearInterval(interval);
  }, [customPaymentId]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        {error}
      </div>
    );
  }

  // Show a "canceled" message if the status is canceled
  if (paymentStatus === "canceled") {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center">
        <h1 className="text-3xl font-bold mb-4">Платеж отменен</h1>
        <p className="mb-4">
          Вы отменили платеж. Если это было сделано по ошибке, попробуйте снова.
        </p>
        <a href="/" className="link underline">
          На главную
        </a>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center">
      {paymentStatus === "succeeded" ||
      paymentStatus === "waiting_for_capture" ? (
        <>
          <h1 className="text-3xl font-bold mb-4">Платеж прошел успешно</h1>
          <p className="mb-4">
            Спасибо за покупку!{" "}
            {gameId ? (
              <a href={`/game/${gameId}`} className="link underline">
                Перейти к игре
              </a>
            ) : (
              <a href="/" className="link underline">
                На главную
              </a>
            )}
          </p>
        </>
      ) : (
        <>
          <h1 className="text-3xl font-bold mb-4">
            Статус платежа: {paymentStatus}
          </h1>
          <p className="mb-4">
            Ваш платеж еще обрабатывается. Пожалуйста, подождите или свяжитесь
            со службой поддержки, если сообщение не исчезнет.
          </p>
        </>
      )}
    </div>
  );
}
